module.exports = __webpack_public_path__ + "img/pro_eight_4.da51b297.jpg";